export const EMPLOYEE_APPLIED_LEAVES = 'employeeLeaveManagement@appliedLeaves';

export default {
    [EMPLOYEE_APPLIED_LEAVES]: {
        url: 'leave/get/my'
    }
};
